import Swup from 'swup';

const swup = new Swup({
  containers: ['#swup'],
});

let observer;

function initScrollReveal() {
  if (observer) observer.disconnect();

  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('reveal');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.1,
      rootMargin: '0px 0px -10% 0px',
    }
  );

  const elements = document.querySelectorAll('.post p, .post img, .post pre, .post ul, .post h1');

  elements.forEach((el) => observer.observe(el));
}

initScrollReveal();

swup.hooks.on('content:replace', () => {
  initScrollReveal();
});
